import * as yup from 'yup'

export const waitlistSchema = yup.object().shape({
  email: yup.string().email().required('Email is required'),
  name: yup.string().required('A name is required'),
})
